import { heroFeatured, heroCards, tickerItems } from '@/mocks/home';

function TickerBar() {
  const loop = [...tickerItems, ...tickerItems];
  return (
    <div className="w-full border-y bg-background-100/80 hairline">
      <div className="flex items-center gap-4 px-4 py-2.5 md:px-6 lg:px-10">
        <span className="flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-3 py-1 text-xs font-bold text-background-50">
          <i className="ri-flashlight-fill text-sm"></i>
          实时围观
        </span>
        <div className="relative flex-1 overflow-hidden">
          <div className="flex w-max animate-marquee items-center gap-8">
            {loop.map((item, idx) => (
              <span
                key={`${item}-${idx}`}
                className="flex items-center gap-2 whitespace-nowrap text-xs text-foreground-600"
              >
                <i className="ri-circle-fill text-[5px] text-primary-400"></i>
                {item}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default function HeroSection() {
  return (
    <section id="top" className="w-full">
      <TickerBar />

      <div className="mx-auto w-full px-4 pb-4 pt-10 md:px-6 md:pt-12 lg:px-10">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 rounded-full border px-3 py-1 text-xs font-semibold text-accent-800 hairline bg-accent-50">
              <i className="ri-fire-line text-sm"></i>
              今日热评聚合
            </span>
            <h2 className="mt-4 font-heading text-2xl font-black leading-snug tracking-tight text-foreground-950 md:text-[34px]">
              评论区吵翻天的那些瓜，
              <br className="hidden sm:block" />
              在这里一次看全
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-[15px]">
              爱黑料网把评论区与讨论区的高赞回复挑出来，配上围观帖的标题与短摘要，方便你顺着线索一路看下去。
            </p>
          </div>
          <div className="flex flex-wrap items-center gap-2.5">
            <a
              href="#comments"
              className="cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              看热评榜
            </a>
            <a
              href="#collections"
              className="cursor-pointer whitespace-nowrap rounded-md border px-5 py-3 text-sm font-semibold text-foreground-800 transition-colors hover:bg-background-100 hairline"
            >
              翻合集索引
            </a>
          </div>
        </div>
      </div>

      <div className="mx-auto w-full px-4 pb-2 md:px-6 lg:px-10">
        <div className="grid grid-cols-1 gap-4 lg:grid-cols-12">
          <article
            className="card-lift group animate-fade-up overflow-hidden rounded-lg border bg-background-50 hairline lg:col-span-5"
            style={{ animationDelay: '60ms' }}
          >
            <div className="relative h-56 w-full overflow-hidden md:h-72 lg:h-[340px]">
              <img
                src={heroFeatured.image}
                alt={`${heroFeatured.title} - 爱黑料网吃瓜帖`}
                title={`${heroFeatured.title} - 爱黑料网网友热议`}
                className="h-full w-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-950/70 via-background-950/10 to-transparent"></div>
              <span className="absolute left-4 top-4 rounded-full bg-primary-500 px-3 py-1 text-xs font-bold text-background-50">
                {heroFeatured.tag}
              </span>
              <div className="absolute inset-x-4 bottom-4">
                <h3 className="font-heading text-lg font-black leading-snug text-background-50 md:text-xl">
                  {heroFeatured.title}
                </h3>
              </div>
            </div>
            <div className="p-4 md:p-5">
              <p className="text-sm leading-relaxed text-foreground-600 line-clamp-2">
                {heroFeatured.summary}
              </p>
              <div className="mt-4 flex flex-wrap items-center gap-x-4 gap-y-2 text-xs text-foreground-500">
                <span className="flex items-center gap-1.5">
                  <i className="ri-user-3-line text-sm"></i>
                  {heroFeatured.author}
                </span>
                <span className="flex items-center gap-1.5">
                  <i className="ri-time-line text-sm"></i>
                  {heroFeatured.time}
                </span>
                <span className="ml-auto flex items-center gap-1.5 font-semibold text-primary-600">
                  <i className="ri-chat-forward-line text-sm"></i>
                  {heroFeatured.meta}
                </span>
              </div>
            </div>
          </article>

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:col-span-7">
            {heroCards.map((card, idx) => (
              <article
                key={card.id}
                className="card-lift group animate-fade-up flex flex-col overflow-hidden rounded-lg border bg-background-50 hairline"
                style={{ animationDelay: `${120 + idx * 60}ms` }}
              >
                <div className="relative h-36 w-full overflow-hidden">
                  <img
                    src={card.image}
                    alt={`${card.title} - 爱黑料网吃瓜帖`}
                    title={`${card.title} - 爱黑料网热评`}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <span className="absolute left-3 top-3 rounded-full bg-accent-500 px-2.5 py-0.5 text-[11px] font-bold text-accent-950">
                    {card.tag}
                  </span>
                </div>
                <div className="flex flex-1 flex-col p-4">
                  <h3 className="font-heading text-sm font-bold leading-snug text-foreground-950 line-clamp-2">
                    {card.title}
                  </h3>
                  <p className="mt-2 text-xs leading-relaxed text-foreground-500 line-clamp-2">
                    {card.summary}
                  </p>
                  <span className="mt-3 flex items-center gap-1.5 text-xs font-semibold text-secondary-700">
                    <i className="ri-discuss-line text-sm"></i>
                    {card.meta}
                  </span>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}